/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

document.addEventListener( 'DOMContentLoaded', () => {
	const faqContainers = document.querySelectorAll(
		'.wp-block-velcome-group-faq-wrapper'
	);

	faqContainers.forEach( ( faqContainer ) => {
		// Event delegation for FAQ toggle
		faqContainer.addEventListener( 'click', ( event ) => {
			const target = event.target.closest(
				'.velcome-blocks-faq-question-button'
			);
			if ( ! target ) return;

			const faqItem = target.closest(
				'.wp-block-velcome-group-faq-item'
			);
			if ( ! faqItem ) return;

			toggleFaqItem( faqItem, faqContainer );
		} );
	} );
} );

function toggleFaqItem( faqItem, faqContainer ) {
	const isActive = faqItem.classList.contains(
		'velcome-blocks-faq-item-active'
	);
	const content = faqItem.querySelector( '.velcome-blocks-faq-content' );

	if ( isActive ) {
		faqItem.classList.remove( 'velcome-blocks-faq-item-active' );
		faqItem.setAttribute( 'aria-expanded', 'false' );
		slideUp( content, 500 );
	} else {
		const shouldCollapseOthers =
			faqContainer.getAttribute( 'data-faqtoggle' ) === 'true';
		if ( shouldCollapseOthers ) {
			const allFaqItems = faqContainer.querySelectorAll(
				'.wp-block-velcome-group-faq-item'
			);
			allFaqItems.forEach( ( item ) => {
				if ( item !== faqItem ) {
					item.classList.remove( 'velcome-blocks-faq-item-active' );
					item.setAttribute( 'aria-expanded', 'false' );
					slideUp(
						item.querySelector( '.velcome-blocks-faq-content' ),
						500
					);
				}
			} );
		}

		faqItem.classList.add( 'velcome-blocks-faq-item-active' );
		faqItem.setAttribute( 'aria-expanded', 'true' );
		slideDown( content, 500 );
	}
}

function slideUp( target, duration ) {
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = `${ duration }ms`;
	target.style.height = `${ target.offsetHeight }px`;
	target.offsetHeight; // Trigger reflow
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	window.setTimeout( () => {
		target.style.display = 'none';
		target.style.removeProperty( 'height' );
		target.style.removeProperty( 'overflow' );
		target.style.removeProperty( 'transition-duration' );
		target.style.removeProperty( 'transition-property' );
		target.style.removeProperty( 'padding-top' );
		target.style.removeProperty( 'padding-bottom' );
		target.style.removeProperty( 'margin-top' );
		target.style.removeProperty( 'margin-bottom' );
	}, duration );
}

function slideDown( target, duration ) {
	target.style.removeProperty( 'display' );
	let display = window.getComputedStyle( target ).display;
	if ( display === 'none' ) display = 'block';

	target.style.display = display;
	target.style.overflow = 'hidden';
	target.style.height = 0;
	target.style.paddingTop = 0;
	target.style.paddingBottom = 0;
	target.style.marginTop = 0;
	target.style.marginBottom = 0;
	target.offsetHeight; // Trigger reflow
	target.style.transitionProperty = 'height, margin, padding';
	target.style.transitionDuration = `${ duration }ms`;
	target.style.height = target.scrollHeight + 'px';
	window.setTimeout( () => {
		target.style.removeProperty( 'height' );
		target.style.removeProperty( 'overflow' );
		target.style.removeProperty( 'transition-duration' );
		target.style.removeProperty( 'transition-property' );
		// Restore padding and margin if needed
	}, duration );
}
